<template>
  <modal
    name="sbp-payment-check"
    width="100%"
    height="auto"
    :scrollable="true"
    :clickToClose="false"
    @opened="openDialogHandler"
  >
    <h1 class="modal-label">Оплата с помощью Системы быстрых платежей</h1>

    <spinner style="margin: 20px auto; zoom: 0.7" />

    <div class="sbp-content">
      <div>
        <p>После успешной оплаты страница автоматически обновится.</p>
        <p v-if="this.theatre.SessionDuration">
          Заказ необходимо оплатить в течение
          {{ this.theatre.SessionDuration }} минут, по истечении времени заказ
          будет отменен.
        </p>
      </div>
    </div>

    <button @click="this.openSlideUpWidget">
      <p>Повторить оплату</p>
    </button>
  </modal>
</template>

<script>
import { mapState } from 'vuex';
import spinner from '@/components/Spinner/Spinner';

export default {
  name: 'SbpPaymentCheck',

  props: ['url', 'paymentId'],

  watch: {
    orderInfo(val) {
      if (val) {
        this.$router.push({ name: 'success' });
      }
    },
  },

  computed: {
    ...mapState(['theatre', 'orderInfo']),
  },
  methods: {
    hide() {
      this.$modal.hide('sbp-payment-check');
    },
    openSlideUpWidget() {
      if (!this.url) return;

      // eslint-disable-next-line no-undef
      const slideUpWidget = new SlideUpWidget(
        window.localStorage,
        window.navigator,
      );

      slideUpWidget.showBankSelector(this.url);
    },
    openDialogHandler() {
      this.$store.dispatch('checkPaymentAndSetOrderInfo', {
        paymentId: this.paymentId,
      });

      this.openSlideUpWidget();
    },
  },
  components: {
    spinner,
  },
};
</script>

<style lang="scss">
.sbp-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.v--modal {
  display: block;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  &-overlay[data-modal='sbp-payment-check'] {
    overflow-x: hidden;
    .b-text {
      margin-bottom: 15px;
      p {
        margin-bottom: 8px;
      }
    }
    .v--modal-box {
      padding: 20px 30px;
    }
    .modal-label {
      padding: 0 70px 10px;
      margin-top: 20px;
    }
  }
}

.modal {
  &-form {
    width: 335px;
  }
  &-label {
    display: block;
    padding: 0 10px 10px;
    font-size: 24px;
    margin-bottom: 20px;
    line-height: 24px;
    letter-spacing: 0.024em;
    color: #fff;
    text-align: center;
  }
  &-input {
    margin-bottom: 15px;
    input {
      border: none;
      outline: none;
      background-color: #fff;
      border-radius: 10px;
      padding: 16px 25px;
      font-size: 18px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 100%;
    }
  }
  &-buttons {
    display: flex;
    flex-wrap: nowrap;
  }
  &-button {
    margin: 0 15px 0 0;
    height: 56px;
    border-radius: 10px;
    border: 1px solid #fff;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #fff;
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 10px;
    text-align: center;
    justify-content: center;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    flex: 1;
    &:last-of-type {
      margin-right: 0;
    }
    &-primary {
      background-color: #0d76ff;
      border-color: transparent;
    }
  }
}

.v--modal-box.v--modal button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  height: 40px;
  border: 2px solid #fff;
  border-radius: 25rem;
  background: white;
  line-height: 1.45;
  cursor: pointer;
  transition: all 0.15s 150ms;
  margin: auto;
}

.v--modal-box.v--modal button:hover {
  opacity: 0.75;
}

@media screen and (max-width: 768px) {
  .v--modal {
    &-overlay[data-modal='sbp-payment-check'] {
      .pz-close-btn {
        top: 10px;
        right: 10px;
      }
      .modal-label {
        margin-top: 30px;
      }
    }
  }
}
</style>
